import React, { useEffect } from 'react';
import { useTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import { ApiButton, TextFieldForm, Typography } from 'web-library';
import { useMediaQuery } from '@mui/material';
import { useUpdatePassword } from '../logic/useUpdatePassword';

const useStyles = makeStyles()((theme) =>
({
  input: {
    marginTop: theme.spacing(2),
  },
  inputRemarks: {
    marginBottom: theme.spacing(3),
  },
  buttonContainer: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
  },
  cancelButton: {
    [theme.breakpoints.down('xl')]: {
      marginLeft: theme.spacing(2),
    },
    [theme.breakpoints.down('lg')]: {
      marginLeft: theme.spacing(0),
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(2),
    },
  },
  confirmButton: {
    marginTop: theme.spacing(3),
  },
  errorText: {
    color: theme.color.state.stateError,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

const UpdatePasswordForm = () => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const { formHook, handleUpdatePassword, putChangePasswordMutation } = useUpdatePassword();
  const { formState: { errors }, control, handleSubmit, watch } = formHook;

  const {
    confirmNewPassword: confirmNewPasswordWatch,
    newPassword: newPasswordWatch,
    oldPassword: oldPasswordWatch,
  } = watch();

  useEffect(() => {
    putChangePasswordMutation.reset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmNewPasswordWatch, newPasswordWatch, oldPasswordWatch]); // DO NOT ADD putChangePasswordMutation TO FIX SONAR

  return (
    <>
      <form onSubmit={handleSubmit(handleUpdatePassword)}>
        <TextFieldForm
          className={classes.inputRemarks}
          variant="outlined"
          id="oldPassword"
          name="oldPassword"
          type="password"
          label={t('profile->>UpdatePassword.OldPassword')}
          error={!!errors?.oldPassword}
          helperText={errors?.oldPassword?.message?.toString()}
          form={formHook}
          isRequired
        />
        <TextFieldForm
          className={classes.inputRemarks}
          variant="outlined"
          id="newPassword"
          name="newPassword"
          type="password"
          label={t('profile->>UpdatePassword.NewPassword')}
          error={!!errors?.newPassword}
          helperText={errors?.newPassword?.message?.toString()}
          form={formHook}
          isRequired
        />
        <TextFieldForm
          className={classes.inputRemarks}
          variant="outlined"
          id="confirmNewPassword"
          name="confirmNewPassword"
          type="password"
          label={t('profile->>UpdatePassword.ConfirmNewPassword')}
          error={!!errors?.confirmNewPassword}
          helperText={errors?.confirmNewPassword?.message?.toString()}
          form={formHook}
          isRequired
        />
        {putChangePasswordMutation.error && (
          <Typography className={classes.errorText}>
            {putChangePasswordMutation.error?.response?.data.message}
          </Typography>
        )}
        <ApiButton
          status={putChangePasswordMutation.status}
          type="submit"
          id="button-confirm"
          className={classes.confirmButton}
          fullWidth={isMobile}
        >
          {t('profile->>UpdatePassword.Confirm')}
        </ApiButton>
      </form>
    </>
  );
};

export default UpdatePasswordForm;
